/**
 * * @module view/gallery.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";
import VimeoPlayer from "@vimeo/player";
import owlCarousel from "owl.carousel";
import Video from "./video"

const Gallery = Backbone.View.extend({
  syncedSecondary: true,
  currentItem: 0,
  oneItemId: undefined,

  initialize: function () {
    this.render();
  },

  galleryCarousel: function () {
    var _this = this;
    let desktop1024ItemsNum = 4;
    const owl = $(".thumbs");

    const options = {
      items: 1.8,
      nav: true,
      dots: true,
      dotsEach: 1,
      loop: true,
      merge: false,
      stagePadding: 39,
      margin: 7,
      touchDrag: true,
      navText: [
        "<span class='icon icon-arrow-left'></span>",
        "<span class='icon icon-arrow-right'></span>",
      ],
      responsive: {
        414: {
          items: 1.8,
        },
        768: {
          items: 4,
          stagePadding: 39,
        },
        1024: {
          items: desktop1024ItemsNum,
          stagePadding: 39,
        },
      },
    };

    if ($("body").hasClass("page-template-default")) {
      desktop1024ItemsNum = 3;
    }


    owl.on("initialized.owl.carousel", (event) => {
      _this.currentItem = event.item.index;
      _this.getInitialContent();
    });

    owl.each(function () {
      const $carousel = $(this);

      const $items = $(".item", $carousel);
      if ($items.length == 1) {
        _this.oneItemId = $carousel.attr("id");
      }

      const owlActive = $carousel.owlCarousel(options);

      $carousel.on("changed.owl.carousel", (event) => {
        var _this = this;
        if (event.item.index == _this.currentItem) {
          return false;
        } else {
          _this.currentItem = event.item.index;

          $(".item", $carousel).removeClass("active-now");
          const $imageWrapper = $carousel.prev(".image-wrapper");
          $imageWrapper.fadeOut(function () {
            let $imageContainer = $(".image-container", $(this));
            $imageContainer.html("");
            $(this).fadeIn();

            const $itemClicked = $(".item", $carousel.find(".owl-item.active")[0]);
            const isVideo = $itemClicked.hasClass("video");
            const isVideoWithNoImage =
              isVideo && $("img", $itemClicked).length == 0;

            if (isVideoWithNoImage) {
              $imageContainer.addClass("video");
            } else {
              $imageContainer.removeClass("video");
            }

            let imageToPlace = $(
              ".item",
              $carousel.find(".owl-item.active")
            ).html();
            $imageContainer.html(imageToPlace);

            if (isVideo) {
              let $link = $(".video-link", $imageContainer);
              $link.attr("href", "#video-modal");
            }
          });
        }
      });

      $carousel.on("click", ".owl-item", function (e) {
        var carousel = $carousel.data("owl.carousel");
        e.preventDefault();
        carousel.to(carousel.relative($(this).index()));

        const $imageWrapper = $carousel.prev(".image-wrapper");
        $imageWrapper.fadeOut(function () {
          let $imageContainer = $(".image-container", $(this));

          $imageContainer.html("");

          $(this).fadeIn();

          const $itemClicked = $(
            ".item",
            $carousel.find(".owl-item.active")[0]
          );
          const isVideo = $itemClicked.hasClass("video");
          const isVideoWithNoImage =
            isVideo && $("img", $itemClicked).length == 0;

          if (isVideoWithNoImage) {
            $imageContainer.addClass("video");
          } else {
            $imageContainer.removeClass("video");
          }

          let imageToPlace = $(
            ".item",
            $carousel.find(".owl-item.active")
          ).html();
          $imageContainer.html(imageToPlace);

          if (isVideo) {
            let $link = $(".video-link", $imageContainer);
            $link.attr("href", "#video-modal");
          }
        });
      });

      $(window).resize(function (event) {
        $carousel.on("resized.owl.carousel", (event) => {
          let $galleryContainer = $(".gallery-container");
          if ($(window).width() < 1009) {
            if (!$galleryContainer.hasClass("resized")) {
              let width = $("body").innerWidth();
              $galleryContainer.width(width).addClass("resized");
            }
          } else {
            if ($galleryContainer.hasClass("resized")) {
              $galleryContainer.width("100%").removeClass("resized");
            }
          }
        });
      });
    });

    // let maxHeight = 0;

    // $(".item", $(owl)).each(function(){
    //   let height = $(this).innerHeight;
    //   if (height > maxHeight){
    //     maxHeight = height;
    //   }
    // });
    // $(".image-wrapper").height(maxHeight);

    if ($(window).width() < 769) {
      let width = $("body").innerWidth();
      $(".gallery-container").width(width).addClass("resized");
    }

    const video = new Video();
    video.loadVideo();
  },

  getInitialContent: function (e) {
    const _this = this;
    const owl = $(".thumbs");

    owl.each(function () {
      const $carousel = $(this);
      const $imageContainer = $carousel.prev(".image-wrapper");
      let $itemClicked = $(".item", $carousel.find(".owl-item.active")[0]);
      let imageToPlace = $(".figure", $itemClicked).html();

      const isVideo = $itemClicked.hasClass("video");
      const isVideoWithNoImage = isVideo && $("img", $itemClicked).length == 0;
      
      if (isVideoWithNoImage) {
        $(".image-container", $imageContainer).addClass("video");
      } else {
        $(".image-container", $imageContainer).removeClass("video");
      }

      $(".image-container", $imageContainer).html(imageToPlace);
      $itemClicked = $(".item", $carousel.find(".owl-item.active")[0]);
      $itemClicked.addClass("active-now");
      $(".overlay", $itemClicked).css("background", "rgba(0,0,0,0.25");

      if (isVideo) {
        let $link = $(".video-link", $imageContainer);
        $link.attr("href", "#video-modal");
      }


      if (_this.oneItemId) {
        let $thumbsThide = $("#" + _this.oneItemId);
        $thumbsThide.hide();

        $thumbsThide.prev().parent().addClass("oneImage");
      }
    });
  },
});

export default Gallery;